import { AfterViewInit, Component, OnInit, HostListener } from '@angular/core';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { OtherService } from 'src/app/services/other.service';

import { Location } from '@angular/common';

import { AccountService } from 'src/app/services/account.service';

import { ToastrService } from 'ngx-toastr';

import { MatDialog } from '@angular/material/dialog';

import { DomSanitizer, SafeUrl, SafeHtml } from '@angular/platform-browser';

import Map from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

import * as olProj from 'ol/proj';

import TileLayer from 'ol/layer/Tile';

import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';

import { Feature, Overlay } from 'ol';

import { Point } from 'ol/geom';

import VectorLayer from 'ol/layer/Vector';

import VectorSource from 'ol/source/Vector';

import { Icon, Style } from 'ol/style';

import Swal from 'sweetalert2';

import {
  debounce,
  debounceTime,
  distinctUntilChanged,
  fromEvent,
  interval,
  pluck,
  takeUntil,
  takeWhile,
} from 'rxjs';

import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';

import { HttpClient } from '@angular/common/http';

declare var bootstrap: any;

@Component({
  selector: 'app-business-detail',

  templateUrl: './business-detail.component.html',

  styleUrls: ['./business-detail.component.css'],

  animations: [
    trigger('slideInOut', [
      state(
        'open',
        style({
          height: '*',

          overflow: 'hidden',

          opacity: '1',

          margin: '10px 0',
        })
      ),

      state(
        'closed',
        style({
          height: '0',

          overflow: 'hidden',

          opacity: '0',
        })
      ),

      transition('open <=> closed', [animate('0.4s ease-in-out')]),
    ]),
  ],
})
export class BusinessDetailComponent implements OnInit {
  fullscreen_ModalStyle: string = `

  max-width: 100vw !important;

  width: 100%;

  height: 100vh;

  max-height: 100vh;

  margin: 0 !important;

  `;

  Info: any;

  htmlContent: any;

  information_ads: any = [];

  list_businessGallery: any;

  current_Image: any;

  captcha: any;

  list_AdsImagesCounter: any;

  list_AdsImages: any = [];

  list_AdsImagesShown: any = [];

  list_City: any = [];

  mainImage_ads: any = '';

  selectedIndex: any = 0;

  isLoading: boolean = true;

  isLoading_2: boolean = true;

  bSendOtp: boolean = false;

  bLoginMode: boolean = true;

  isFromLoginForm: boolean = false;

  isFromAnotherComponent: boolean = false;

  rulesRead: boolean = false;

  isLogin: boolean;

  otpTimer: any | number = 0;

  map: any = {};

  id: string;

  type: string;

  sliderSimilar: any;

  iAdvertising: string;

  redirectTo: string;

  redirectTo_id: number | string | null = null;

  signUpModel: FormGroup = this.formBuilder.group({
    strMobile: new FormControl('', Validators.required),

    strEmail: new FormControl(''),

    strOtp: new FormControl(''),

    tiSex: new FormControl(1),

    strName: new FormControl(''),

    strCaptcha: new FormControl(''),

    strFamily: new FormControl('', Validators.required),

    strCityCode: new FormControl('-1', Validators.required),

    strPassword: new FormControl(''),

    fLat: new FormControl(0),

    fLon: new FormControl(0),

    strImei: new FormControl(''),

    iOTP: new FormControl(''),

    rules: new FormControl(false),
  });

  carouselOptions = {
    items: 1,
    rtl: true,
    loop: true,
    autoplay: false,
    autoplayTimeout: 3000, // Adjust the autoplay timeout as needed
    autoplayHoverPause: true,
    dots: false,
    nav: false, // Set to true if you want navigation arrows
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      992: {
        items: 5,
      },
    },
  };

  constructor(
    public route: ActivatedRoute,

    private location: Location,

    private toastr: ToastrService,

    private router: Router,

    private dialog: MatDialog,

    private formBuilder: FormBuilder,

    private accountService: AccountService,

    private otherService: OtherService,

    private sanitizer: DomSanitizer,

    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.route.url.pipe(pluck(0, 'path')).subscribe((segment: any) => {
      if (segment == 'login') {
        if (this.accountService.list_StoredCity.length != 0) {
          this.list_City = this.accountService.list_StoredCity;
        }

        this.route.paramMap.subscribe((params) => {
          this.redirectTo = params.get('redirectTo');

          this.redirectTo_id = params.get('id');
        });

        this.isFromAnotherComponent = true;

        this.isLoading = false;

        this.isLoading_2 = false;

        setTimeout(() => {
          this.open_SigUpModal();
        }, 100);
      }

      if (segment == 'ads') {
        this.route.paramMap.subscribe((params) => {
          this.id = params.get('id');

          this.type = params.get('type');

          this.iAdvertising = params.get('iAdvertising');

          this.Info = this.otherService.getLocalStorage();

          var model = {
            iUserManager_User: this.Info?.Id,

            strSession: this.Info?.session,

            iMainKey: this.id,

            tiType: this.type,

            iAdvertising: this.iAdvertising,
          };
        });
      }
    });

    this.otherService.isUserLogin$.subscribe((condition) => {
      this.isLogin = condition;
    });

    this.get_Captcha();
  }

  getSafeHtml(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  beforeUnloadHandler(event: Event) {
    this.showAlertBeforeClosing();
  }

  showAlertBeforeClosing() {
    const confirmation = confirm('Are you sure you want to leave this page?');
    if (confirmation) {
    } else {
    }
  }

  openAdd() {
    window.open(`/general`, '_blank');
  }

  checkRules(e) {
    this.rulesRead = e.target.checked;
  }

  openPicFull(e) {
    var myModal = new bootstrap.Modal(document.getElementById('imgModal'), {});
    myModal.show();
  }

  callWith_advertiser() {
    window.location.href = 'tel:' + this.information_ads.strMobile;
  }

  shareVia() {
    if (navigator.share) {
      navigator
        .share({
          url: window.location.href,

          title: this.information_ads.strTitle,
        })
        .then(() => console.log('اشتراک گذاری موفق'))

        .catch(() =>
          this.accountService.toastSwal('error', 'متاسفانه خطایی رخ داده است')
        );
    } else
      this.accountService.toastSwal(
        'error',
        'قابلیت اشتراک گذاری برای شما پشتیبانی نمی شود'
      );
  }

  open_SigUpModal() {
    this.signUpModel.reset();
    this.signUpModel.controls['tiSex'].setValue(1);

    this.bLoginMode = true;
    this.bSendOtp = false;

    this.isFromLoginForm = false;

    this.signUpModel.get('strMobile').enable();

    var myModal = new bootstrap.Modal(
      document.getElementById('exampleModal'),
      {}
    );

    myModal.show();
  }

  login_User() {
    var model = {
      strMobile: this.signUpModel.get('strMobile')?.value,
      strCaptcha: this.captcha.strCaptcha,
      strSessionID: this.captcha.strSessionID,
    };

    this.accountService.taxiLogin(model).subscribe((data) => {
      let res = JSON.parse(data.toString());

      if (res.iResult == -2) {
        this.get_Captcha()
        return this.accountService.toastSwal('error', res.strError);
      }

      if (res.bError)
        return this.accountService.toastSwal('error', res.strError);

      if (res.length !== 0) {
        // console.log('login_User')

        this.bLoginMode = false;

        this.bSendOtp = true;

        this.isFromLoginForm = true;

        this.signUpModel.get('strMobile').disable();

        setTimeout(() => {
          this.startOtp_Timer();
        }, 10);
      } else {
        this.isFromLoginForm = false;

        this.bLoginMode = false;

        this.bSendOtp = false;

        this.signUpModel.controls['strCityCode'].setValue('-1');
      }
    });
  }

  signUp_User() {
    if (this.signUpModel.invalid)
      return this.accountService.toastSwal(
        'error',

        'لطفا موارد ستاره دار را پر کنید'
      );

    if (this.signUpModel.get('strMobile')?.value.length < 10)
      return this.accountService.toastSwal(
        'error',
        'لطفا شماره موبایل را به درستی وارد کنید'
      );

    this.accountService
      .taxiSubmit(this.setEmptyString4NullValues(this.signUpModel.value))
      .subscribe((data) => {
        let res = JSON.parse(data.toString());

        if (res.bError)
          return this.accountService.toastSwal('error', res.strError);

        this.bSendOtp = true;

        this.signUpModel.get('strMobile').disable();

        this.get_Captcha()

        setTimeout(() => {
          this.startOtp_Timer();
        }, 10);
      });
  }

  startOtp_Timer() {
    const changeNumber_btn = document.getElementById('changeNumber-btn');

    const onChangeNumberClicked$ = fromEvent(changeNumber_btn, 'click');

    interval(1000)
      .pipe(
        takeWhile((value) => value <= 60),

        takeUntil(onChangeNumberClicked$)
      )
      .subscribe({
        next: (value) => {
          const minutes = Math.floor((60 - value) / 60)
            .toString()
            .padStart(2, '0');

          const seconds = ((60 - value) % 60).toString().padStart(2, '0');

          this.otpTimer = `${minutes}:${seconds}`;
        },

        error: (err) => console.error(err),

        complete: () => (this.otpTimer = 0),
      });
  }

  check_Otp() {
    var model = {
      strMobile: this.signUpModel.get('strMobile')?.value,
      iOTP: this.signUpModel.get('iOTP')?.value,
    }

    this.accountService.taxiCheckOTP(model).subscribe((userData) => {
      let res = JSON.parse(userData.toString());
      let resParse = res[0] ?? res;

      if (resParse.iResult == 0) {
        this.accountService.toastSwal('error', resParse.strError);
      }
      else {
        this.accountService.toastSwal('success', ` ${resParse.strName + ' ' + resParse.strFamily} خوش آمدید `);

        var data = {
          strCityName: resParse.strCityName,
          session: resParse.strSession,
          Id: resParse.iTaxiLon_User,
          strName: resParse.strName,
          strFamily: resParse.strFamily,
          strID: resParse.strID,
          strMobile: resParse.strMobile,
          tiSex: resParse.tiSex,
          strCity: resParse.strCity,
          strAddress: resParse.strAddress,
          strBankAccount: resParse.strBankAccount,
          strAvatar: resParse.strAvatar,
          strFullName: resParse.strFullName,
          fLat: resParse.fLat,
          fLon: resParse.fLon,
          CityCode: resParse.strCityCode,
          strVehicleNo: resParse.strVehicleNo,
        };

        localStorage.setItem(
          'db30a17f18d1a8a3l0ifr4z8ab0b02',
          this.accountService.encrypt(JSON.stringify(data))
        );
        // set user location to default selected city

        var selectedCity = {
          strCityCode: data.CityCode,

          strCityName: data.strCityName,
        };

        localStorage.removeItem('dc30al1i7rez0ab02');

        localStorage.setItem(
          'dc30al1i7rez0ab02',
          this.accountService.encrypt(JSON.stringify(selectedCity))
        );

        this.otherService.changeUserSelectedCity_Status(true);

        this.Info = this.otherService.getLocalStorage();

        this.closeSignUp_Modal();

        var bookmarkModel = {
          iUserManager_User: this.Info?.Id,

          strSession: this.Info?.session,

          iMainKey: this.id,

          tiType: this.type,
        };

        if (this.isFromAnotherComponent) {
          if (this.redirectTo_id)
            return this.router.navigate([
              `/${this.redirectTo}/${this.redirectTo_id}`,
            ]);
          else this.router.navigate([`/${this.redirectTo}`]);
        }

        this.otherService.changeUserLogin_Status(true);

        this.accountService.list_StoredAds = [];

        this.accountService.list_StoredCity = [];
      }
    });
  }

  sendAgain_Otp() {
    var model = {
      strMobile: this.signUpModel.get('strMobile')?.value,
    };
    this.get_Captcha()
    this.bSendOtp = false
    this.bLoginMode = true
  }

  closeSignUp_Modal() {
    if (this.isFromAnotherComponent) this.router.navigate(['dyar/home']);

    let myModal = document.getElementById('exampleModal');

    var modal = bootstrap.Modal.getInstance(myModal);

    modal.hide();

    this.bLoginMode = true;

    this.bSendOtp = false;

    this.isFromLoginForm = false;

    this.signUpModel.get('strMobile').enable();

    this.router.navigate([`/home`]);
  }

  setEmptyString4NullValues(obj: any) {
    for (const key in obj) {
      if (obj[key] === null) obj[key] = '';
    }

    return obj;
  }

  get_Captcha() {
    this.accountService.Captcha_Get().subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      this.captcha = res;
    });
  }

  filterNumericInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9۰-۹]/g, '')
  }
}
